
// Catalog filter accordion
var filterHeight;
// var currentFilters = [];
$(document).on('click', '.accordion-item__header', function(e) {
  e.preventDefault();
  if($(this).hasClass('opened')) {
    $(this).removeClass('opened');
    $(this).next('.accordion-item__body').css({'height': '0'});
  } else {
    $(this).addClass('opened');
    filterHeight = $(this).next('.accordion-item__body').prop('scrollHeight');
    $(this).next('.accordion-item__body').css({'height': filterHeight});
  }
});


$(document).ready(function() {

  // Validation for price input
  $('.filter-block').on('input', '.price_input input', function() {

    let start = this.selectionStart;
    let end = this.selectionEnd;

    const current = this.value
    const corrected = current.replace(/([^0-9]+)/gi, '');
    this.value = corrected;

    if (corrected.length < current.length) --end;
    this.setSelectionRange(start, end);
    var priceMin = $(this).parent().parent().find('.price_input:first-child input');
    var priceMax = $(this).parent().parent().find('.price_input:last-of-type input');
    var priceFrom = parseFloat(priceMin.val());
    var priceTo = parseFloat(priceMax.val());
    if(priceFrom > priceTo) {
      priceMin.val(parseInt(priceMax.val()) - 1) ;
    }
    if(priceTo < priceFrom) {
      priceMax.val(parseInt(priceMin.val()) + 1);
    }

    if(priceMin.val()[0] == 0) {
      priceMin.val(priceMin.val().replace('0', ''));
    }
    if(priceMax.val()[0] == 0) {
      priceMax.val(priceMax.val().replace('0', ''));
    }

    if(priceMax.val().length == 0) {
      priceMax.val('0');
      priceMin.val('0');
    }
    if(priceMin.val().length == 0) {
      priceMin.val('0');
    }

    if(parseFloat(priceMax.val()) > parseFloat(priceMax.attr('value'))) {
      priceMax.val(priceMax.attr('value'));
    }
  });

  // price range
  const $xhrFilterWrap = $('#xhr-catalog-wrap');
  function initialRangeSlider() {
    var $slider = $('body').find("#slider-range");
    //Get min and max values
    var priceMin = $slider.attr("data-price-min-val"),
        priceMax = $slider.attr("data-price-max-val");

    //Set min and max values where relevant
    $("#priceFrom").attr({
      "min": priceMin,
      "max": parseInt(priceMax) - 1
    });
    $("#priceTo").attr({
      "min": parseInt(priceMin) + 1,
      "max": priceMax
    });
    $("#priceFrom").attr({
      "placeholder": "min " + priceMin,
      "value": priceMin
    });
    $("#priceTo").attr({
      "placeholder": "max " + priceMax,
      "value": priceMax
    });
    $slider.slider({
      range: true,
      min: Math.max(priceMin, 0),
      max: priceMax,
      values: [priceMin, priceMax],
      slide: function (event, ui) {
        $("#priceFrom").val(ui.values[0]);
        $("#priceTo").val(ui.values[1]);
      }
    });

    $("#priceFrom, #priceTo").map(function () {
      $(this).on("blur", function () {
        let pfV = $("#priceFrom").val(),
            pfT = $("#priceTo").val(),
            pfMin = $("#priceFrom").attr('min'),
            pfMax = $("#priceTo").attr('max');

        if(pfV === pfMin && pfT === pfMax) return;

        updateSlider();
      });
    });

    function updateSlider() {
      $slider.slider({
        values: [$("#priceFrom").val(), $("#priceTo").val()]
      });

      //Update filter
      $xhrFilterWrap.trigger('price.change.watching', [
        $("#priceFrom").val(),
        $("#priceTo").val(),
        $("#priceFrom").attr('min'),
        $("#priceTo").attr('max')
      ]);
    }

    $slider.on("slidestop", function () {
      let pfV = $("#priceFrom").val(),
          pfT = $("#priceTo").val(),
          pfMin = $("#priceFrom").attr('min'),
          pfMax = $("#priceTo").attr('max');

      if(pfV === pfMin && pfT === pfMax) return;

      if ($('.price_input:last-of-type input').val()[0] == 0) {
        $('.price_input:last-of-type input').val('1');
      }

      if (parseFloat($('.price_input:last-of-type input').val()) == parseFloat($('.price_input:first-child input').val())) {
        $('.price_input:first-child input').val(parseInt($('.price_input:last-of-type input').val()) - 1);
      }

      if (!$('.selected-filters-form input:checked').length && parseInt($('.price_input:last-of-type input').val()) == $('.price_input:last-of-type input').attr('max') && parseInt($('.price_input:first-child input').val()) == parseInt($('.price_input:first-child input').attr('min'))) {
        $('.selected-filters-block').slideUp();
      } else {
        $('.selected-filters-block').slideDown();

        // if(parseInt($('.price_input:last-of-type input').val()) !== parseInt($('.price_input:last-of-type input').attr('max')) || parseInt($('.price_input:first-child input').val()) !== parseInt($('.price_input:first-child input').attr('min'))) {
        //   $('.selected-filters-list').append('<div><span data-id="price">' + $("#priceFrom").val() + '-' + $("#priceTo").val() + '</span><a href="" class="selected-filters-link"><i class="remove-filter"></i></a></div>');
        // }
      }

      //Update filter
      $('#xhr-catalog-wrap').trigger('price.change.watching', [pfV, pfT, pfMin, pfMax]);

    });
  }
  initialRangeSlider();

  $xhrFilterWrap.bind('initial.range.values', function () {
    initialRangeSlider();
  })


  // сбросить всё
  $('.filter-block').on('click', '#reset-all, .clear-filter', function (e) {
        // e.preventDefault();
        // e.stopPropagation();

    $('#priceFrom').val($('#slider-range').attr('data-price-min-val'));
    $('#priceTo').val($('#slider-range').attr('data-price-max-val'));

    $xhrFilterWrap.trigger('price.change.watching', [
      $("#priceFrom").val(),
      $("#priceTo").val(),
      $("#priceFrom").attr('min'),
      $("#priceTo").attr('max')
    ]);

    $('.filter-block').find('input[type="checkbox"]').prop('checked', false);

    $('.selected-filters-block').find('.selected-filters-list > div').remove();
    $('#priceFrom').val($('#priceFrom').attr('data-min'));
    $('#priceTo').val($('#priceTo').attr('data-max'));
    $('.selected-filters-block').find('input[type="checkbox"]').prop('checked', false);
  });


  //hide filters block
  if($('.selected-filters-list span').length == 0) {
    $('.selected-filters-block').hide();
  }
  //delete selected filter
  $('#xhr-filter').on('click', '.selected-filters-link', function(e) {
        e.preventDefault();
        e.stopPropagation();

    if($(this).siblings('span').attr('data-id') == 'price') {
      $('.price_input:first-child input').val($('.price_input:first-child input').attr('value'));
      $('.price_input:last-child input').val($('.price_input:last-child input').attr('value'));

      $xhrFilterWrap.trigger('price.change.watching', [
        $("#priceFrom").val(),
        $("#priceTo").val(),
        $("#priceFrom").attr('min'),
        $("#priceTo").attr('max')
      ]);

    } else {
      $('label[for="' + $(this).siblings('span').attr('data-id') + '"]').trigger('click');
    }
    $(this).parent().remove();
    if($('.selected-filters-list span').length == 0) {
        $('.selected-filters-block').slideUp();
    }
  });

  //added selected checkbox
  $('.filter_block ').on('click', '.accordion-item__body label', function() {
      if($(this).siblings('input').is(':checked')) {
        console.log('checked');
          $('.selected-filters-block').find('span[data-id="' + $(this).attr('for') + '"]').parent().remove();
          if(!$('.selected-filters-list span').length) {
            $('.selected-filters-block').slideUp();
          }
      } else {
        console.log('not checked')
          if($('.selected-filters-block span').length == 0) {
            $('.selected-filters-block').slideDown();
          }
          $('.selected-filters-list').append('<div><span data-id="' + $(this).attr('for') + '">' + $(this).text() + '</span><a href="" class="selected-filters-link"><i class="remove-filter"></i></a></div>');
      }
  });

  //added price
  $('.filter_block').on('blur', '.price_input input', function() {
      if($('.selected-filters-block .price').length)  {
        $('.selected-filters-block .price').remove();
      }

      if($('.selected-filters-block span').length == 0) {
        $('.selected-filters-block').slideDown();
      }

      if($(this).parent().is(':first-child')) {
        $('.selected-filters-list').append('<div><span data-id="price">' + $(this).val() + '-' + $(this).parent().siblings('.price_input').find('input').val() + '</span><a href="" class="selected-filters-link"><i class="remove-filter"></i></a></div>');
      } else {
        $('.selected-filters-list').append('<div><span data-id="price">' + $(this).parent().siblings('.price_input').find('input').val() + '-' + $(this).val() + '</span><a href="" class="selected-filters-link"><i class="remove-filter"></i></a></div>');
      }

      if($('.price_input:last-of-type input').val()[0] == 0) {
        $('.price_input:last-of-type input').val('1');
      }

      if(parseFloat($('.price_input:last-of-type input').val()) == parseFloat($('.price_input:first-child input').val())) {
        $('.price_input:first-child input').val(parseInt($('.price_input:last-of-type input').val()) - 1);
      }

      if(!$('.selected-filters-form input:checked').length && parseInt($('.price_input:last-of-type input').val()) == $('.price_input:last-of-type input').attr('max') && parseInt($('.price_input:first-child input').val()) == parseInt($('.price_input:first-child input').attr('min'))) {
        $('.selected-filters-block').slideUp();
      } else {
        $('.selected-filters-block').slideDown();

        // if(parseInt($('.price_input:last-of-type input').val()) !== parseInt($('.price_input:last-of-type input').attr('max')) || parseInt($('.price_input:first-child input').val()) !== parseInt($('.price_input:first-child input').attr('min'))) {
        //   $('.selected-filters-list').append('<div><span data-id="price">' + $("#priceFrom").val() + '-' + $("#priceTo").val() + '</span><a href="" class="selected-filters-link"><i class="remove-filter"></i></a></div>');
        // }
      }
  });

  $('body').on('click', '.sort-button-block .btn', function() {
    $(this).closest('.sort-block').find('.btn-close').trigger('click');
  });
});
